import React, { useEffect, useState } from 'react';
import { CloseableModal } from '../../../components/CloseableModal';
import { ModalBody } from './ModalBody';
import { InterviewList } from '../../../entities/v1/applicant_tracking/InterviewList';
import { InterviewService } from '../../../services/v1/applicant_tracking/InterviewService';
import { InterviewTemplateList } from '../../../entities/v1/applicant_tracking/InterviewTemplate';
import { InterviewTemplateService } from '../../../services/v1/applicant_tracking/InterviewTemplateService';

interface PropTypes {
  OnClose: () => void;
  isOpen: boolean;
  userId: number;
}

export function DeactivateUserModal(props: PropTypes) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [interviewList, setInterviewList] = useState<InterviewList>(null);
  const [interviewTemplateList, setInterviewTemplateList] =
    useState<InterviewTemplateList>(null);

  useEffect(() => {
    setIsLoading(true);
    const interviewsPromise = InterviewService.list({
      organizerUserId: props.userId,
      status: 'scheduled',
    });

    const interviewTemplatesPromise =
      InterviewTemplateService.listInterviewTemplatesByOrganizerUser({
        organizerUserId: props.userId,
      });

    Promise.all([interviewsPromise, interviewTemplatesPromise])
      .then(([interviews, templates]) => {
        setInterviewList(interviews);
        setInterviewTemplateList(templates);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={() => props.OnClose()}
      isOpen={props.isOpen}
      size='md'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerTitle={'Deactivate User'}
      bodyChildren={
        <ModalBody
          isLoading={isLoading}
          interviewTemplateList={interviewTemplateList}
          interviewList={interviewList}
          handleClose={props.OnClose}
          userId={props.userId}
          setIsLoading={setIsLoading}
        />
      }
    />
  );
}
